import { AfterViewInit, Directive, ElementRef, Input, OnChanges, Renderer2 } from '@angular/core';
import { PermissionManagerService } from './authmanager/permission-manager.service';
import { PermissionType } from './authmanager/permission-type';
import { ModulesType } from './authmanager/modules-type';


const DISABLED = 'disabled';
const APP_DISABLED = 'app-disabled';
const TAB_INDEX = 'tabindex';
const TAG_ANCHOR = 'a';
const COLOR_CLASS = 'color-class';

@Directive({
    selector: '[appDisable]'
})
export class DisableDirective implements OnChanges, AfterViewInit {

    //@Input() appDisable = true;
    @Input("moduleType") moduleType: string;
    @Input("accessType") accessType: string;
    modType: ModulesType;
    accType: PermissionType;

    constructor(private eleRef: ElementRef, private renderer: Renderer2, private permissionManagerS: PermissionManagerService) { }

    ngOnChanges() {
        this.modType = ModulesType[this.moduleType];
        this.accType = PermissionType[this.accessType];

        this.disableElement(this.eleRef.nativeElement);
    }

    ngAfterViewInit() {

        this.modType = ModulesType[this.moduleType];
        this.accType = PermissionType[this.accessType];

        this.disableElement(this.eleRef.nativeElement);
    }

    private disableElement(element: any) {
        if (!this.permissionManagerS.isGranted(this.accType, this.modType)) {
            if (!element.hasAttribute(DISABLED)) {
                this.renderer.setAttribute(element, APP_DISABLED, '');
                this.renderer.setAttribute(element, DISABLED, 'true');
                this.renderer.setAttribute(element, COLOR_CLASS, '');
                this.renderer.removeClass(element,'active');


                // disabling anchor tab keyboard event
                if (element.tagName.toLowerCase() === TAG_ANCHOR) {
                    this.renderer.setAttribute(element, TAB_INDEX, '-1');
                }
            }
        } else {
            if (element.hasAttribute(APP_DISABLED)) {
                if (element.getAttribute('disabled') !== '') {
                    element.removeAttribute(DISABLED);
                }
                element.removeAttribute(APP_DISABLED);
                if (element.tagName.toLowerCase() === TAG_ANCHOR) {
                    element.removeAttribute(TAB_INDEX);
                }
            }
        }
        if (element.children) {
            for (let ele of element.children) {             
                this.disableElement(ele);
            }
        }
    }
}